import React, { useEffect } from "react";

import { doc } from "firebase/firestore";
import { useFirestore, useFirestoreDocData } from "reactfire";
import { useRound } from "context/roundContext";
import { useLeague } from "context/leagueContext";
import { useUser } from "reactfire";

import { useEventPick } from "context/eventPickContext";

function useEventPickData(event) {
  const { status, data: user } = useUser();

  const {
    state: { leagueInfo, nextRoundId, leagueUserData },
  } = useLeague();
  const { dispatch } = useEventPick();
  const {
    state: { currentRound, isLoading },
  } = useRound();

  const eventPickDataRef = doc(
    useFirestore(),
    "userTournaments/" +
      leagueInfo?.id +
      "/rounds/" +
      currentRound?.id +
      "/users/" +
      user?.uid +
      "/events/",
    event?.id
  );
  const { status: eventPickDataStatus, data: eventPickData } =
    useFirestoreDocData(eventPickDataRef, {
      idField: "id",
    });

  const type =
    leagueInfo?.gameRule == 0 || leagueInfo?.gameRule == 4
      ? "set1x2Event"
      : leagueInfo?.gameRule == 1 || leagueInfo?.gameRule == 3
      ? "setCorrectScoreEvent"
      : leagueInfo?.gameRule == 2 && "setLmsEvent";

  useEffect(() => {
    if (eventPickDataStatus === "success") {
      dispatch({
        type: type,
        value: {
          eventData: event,
          eventPickData: eventPickData,
          leagueData: leagueInfo,
          currentRound: currentRound,
          type: type,
          nextRoundId: nextRoundId,
          leagueUserData: leagueUserData,
        },
      });
    }
  }, [eventPickDataStatus, eventPickData]);

  return null;
}

export { useEventPickData };
